import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Stub from "@/pages/Stub";
import NotFound from "@/pages/NotFound";
import Division from "@/pages/Division";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import { Projects, ProjectDetail } from "@/pages/Projects";
import CookiePolicy from "@/pages/CookiePolicy";
import Booking from "@/pages/Booking";
import Team, { TeamMember } from "@/pages/Team";
import LegalPage from "@/pages/LegalPage";
import {
  WhyChooseUs, Industries, ClientsPartners, Certifications, Faq, News,
} from "@/pages/TrustPages";
import AdminApp from "@/admin/AdminApp";
import DcApp from "@/dc/DcApp";

export default function App() {
  // Admin shell lives on /admin/* and has its own router context.
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
    return <AdminApp />;
  }
  if (typeof window !== "undefined" && window.location.pathname.startsWith("/dc")) {
    return <DcApp />;
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/divisions/:slug" element={<Division />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/clients-partners" element={<ClientsPartners />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/news" element={<News />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:slug" element={<TeamMember />} />
          <Route path="/privacy" element={<LegalPage slug="privacy" fallbackTitle="Privacy policy" fallbackDescription="Privacy policy will be published shortly." />} />
          <Route path="/terms" element={<LegalPage slug="terms" fallbackTitle="Terms of service" fallbackDescription="Terms of service will be published shortly." />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
